// test1255
(1255 && 0);
